/**
 * RecoveryBanner
 * Toont een herstel-optie als er een niet-verzonden opname in IndexedDB staat.
 */

import React from 'react';
import { PendingRecording } from '../hooks/useRecordingStorage';

interface RecoveryBannerProps {
  record: PendingRecording;
  onRetry: (record: PendingRecording) => void;
  onDiscard: () => void;
}

export const RecoveryBanner: React.FC<RecoveryBannerProps> = ({
  record,
  onRetry,
  onDiscard,
}) => {
  const date = new Date(record.timestamp);
  const dateStr = date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' });
  const timeStr = date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="alert alert-warning">
      <span className="alert-icon">💾</span>
      <div className="alert-body">
        <strong>Niet-verzonden opname gevonden</strong>
        <span>
          {dateStr} om {timeStr} — inwoner: <strong>{record.inwoner}</strong>
        </span>
        <div className="alert-actions">
          <button className="btn-inline btn-inline-primary" onClick={() => onRetry(record)}>
            Opnieuw verzenden
          </button>
          <button className="btn-inline btn-inline-secondary" onClick={onDiscard}>
            Verwijderen
          </button>
        </div>
      </div>
    </div>
  );
};
